import { render, staticRenderFns } from "./Achievement_details.vue?vue&type=template&id=3ba8dce2&scoped=true"
import script from "./Achievement_details.vue?vue&type=script&lang=js"
export * from "./Achievement_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8dce2",
  null
  
)

export default component.exports